import Pristine from 'pristinejs';

let pristine;

const init = () => {
  const enquiryForm = document.getElementById('enquiry-form');
  const artistEnquiryForm = document.getElementById('artist-enquiry-form');

  if (!!enquiryForm) {
    setupEnquiryForm(enquiryForm);
  }

  if (!!artistEnquiryForm) {
    setupEnquiryForm(artistEnquiryForm);
  }

  document.querySelectorAll('.js-toggle-contact').forEach(e =>
    e.addEventListener('click', toggleNav, false));
};

function setupEnquiryForm(form) {

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    pristine = new Pristine(form);
    const isValid = pristine.validate();

    if (!isValid) {
      console.log(pristine.getErrors(), 'form is NOT valid');
      return;
    }
    console.log('form is valid');
    // send form
    sendEnquiry(form);
  });
}

function sendEnquiry(form) {
  // Collect the form data while iterating over the inputs
  const data = {};
  const formData = new FormData(form);
  for (let input of formData) {
    if(formData.getAll(input[0]).length > 1) {
      // input name has more than one value (probably checkboxes)
      if(!!data[input[0]]) {
        data[input[0]].push(input[1])
      } else {
        data[input[0]] = [input[1]];
      }
    } else {
      data[input[0]] = input[1];
    }
  }

  // Construct an HTTP request
  const xhr = new XMLHttpRequest();
  xhr.open(form.method, '/', true);
  xhr.setRequestHeader('Accept', 'application/json; charset=utf-8');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

  // Send the collected data as encoded form data
  xhr.send(new URLSearchParams(formData).toString());

  // Callback function
  xhr.onloadend = (response) => {
    switch (response.target.status) {
      case 200:
        form.querySelector('.js-submit-btn')
          .classList.add('is-hidden');
        form.querySelector('.js-enquiry-success-message')
          .classList.remove('is-hidden');
        console.log('success', response);
        break;
      default:
        console.log('unknown status', response);
        break;
    }
  };
}


function toggleNav(event) {
  const ContactOverlayId = 'contact_overlay';
  event.preventDefault();
  if(!document.getElementById(ContactOverlayId)) {
    return;
  }
  document.getElementById(ContactOverlayId).classList.toggle('is-hidden');
  document.body.classList.toggle('u-vp-no-scroll');
};


export default {init};
